import { BasicAppliedFilters } from 'app/components/design-system-components/list-filters/BasicAppliedFilters'
import { buildRenderedFilterConfig } from 'app/sm/manager_viewings/ManagerViewingsFilters/filters.config'

type ManagerViewingsAppliedFiltersProps = {
  filters: any
  onDismissFilter: any
  enableFilters: any
  includeListingStatusFilter?: boolean
}

export const ManagerViewingsAppliedFilters = ({
  filters,
  onDismissFilter,
  enableFilters,
  includeListingStatusFilter = false,
}: ManagerViewingsAppliedFiltersProps) => {
  return (
    <BasicAppliedFilters
      filtersConfig={buildRenderedFilterConfig(filters, undefined, {
        includeListingStatusFilter,
      })}
      onDismissFilter={onDismissFilter}
      enableFilters={enableFilters}
    />
  )
}
